export const runPool = async <T>(
  items: readonly T[],
  concurrency: number,
  worker: (item: T) => Promise<void>,
  signal?: AbortSignal
) => {
  let next = 0;
  const limit = Math.max(1, Math.min(concurrency, items.length));
  await Promise.all(
    Array.from({ length: limit }, async () => {
      while (next < items.length) {
        if (signal?.aborted) return;
        const current = next;
        next += 1;
        await worker(items[current]);
      }
    })
  );
};
